import { loginMode } from '../../api/login'
import * as types from '../mutation-types'
import { getSessionId, setSessionId, removeSessionId, getLoginState, setLoginState, removeLoginState, setNewPersonFreeOrderCount, getNewPersonFreeOrderCount } from '../../utils/auth'
import { getStore, setStore } from '@/utils/session'
import Utils from '@/utils/base'

const finishedStoreName = 'HAVE_UNFINISHED_ORDER'

// initial state
const state = {
  versionCode: '', // 应用版本号
  sessionId: getSessionId(), // session
  loginState: getLoginState(), // 登录态,
  isApp: false, // 是否是通过uniapp访问
  isAuthorized: false, // app是否授权成功
  newPersonFreeOrderCount: getNewPersonFreeOrderCount(), // 新人权益订单数
  iosIsShowLoginBtn: false, // ios端是否展示苹果登录按钮
  isHaveUnfinishedOrder: getStore(finishedStoreName) ? getStore(finishedStoreName) : false // 是否存在未完成的订单
}

// getters
const getters = {
  versionCode: (state) => state.versionCode,
  sessionId: (state) => state.sessionId,
  loginState: (state) => state.loginState,
  getIsApp: (state) => state.isApp,
  getIsAuthorized: (state) => state.isAuthorized,
  getNewPersonFreeOrderCount: (state) => state.newPersonFreeOrderCount,
  getIosIsShowLoginBtn: (state) => state.iosIsShowLoginBtn,
  getIsHaveUnfinishedOrder: (state) => state.isHaveUnfinishedOrder
}

// actions
const actions = {
  // 用户名登录
  loginMode({ commit }, code) {
    return new Promise((resolve, reject) => {
      loginMode(code)
        .then((response) => {
          commit(types.RECEIVE_SESSION_ID, response.Data.tokenid)
          commit(types.RECEIVE_LOGIN_STATE, response.Data.isLogin)
          // 是否有未完成的订单
          // setStore('HAVE_UNFINISHED_ORDER', response.Data.hasOrder)
          commit('SET_IS_HAVE_UNFINISHED_ORDER', response.Data.hasOrder)
          // 新人权益订单数
          commit(types.SET_NEW_PERSON_FREE_ORDER_COUNT, response.Data.newPersonFreeOrderCount)
          // 是否新人。isNewPerson 为true时，storage会设置值，false或其他假值则相应的storage会自动删除
          Utils.setNewcomerStorage(response.Data.isNewPerson)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  loginOut({ commit }) {
    return new Promise((resolve) => {
      commit(types.RECEIVE_SESSION_ID, '')
      commit(types.RECEIVE_LOGIN_STATE, '')
      resolve()
    })
  }
}

// mutations
const mutations = {
  SET_VERSION_CODE(state, versionCode) {
    state.versionCode = versionCode
  },
  [types.RECEIVE_SESSION_ID](state, sessionId) {
    state.sessionId = sessionId
    if (sessionId === '') {
      removeSessionId()
    } else {
      setSessionId(sessionId)
    }
  },
  [types.RECEIVE_LOGIN_STATE](state, loginState) {
    state.loginState = loginState
    if (loginState === '') {
      removeLoginState()
    } else {
      setLoginState(loginState)
    }
  },
  [types.SET_IS_APP](state, isApp) {
    state.isApp = isApp
  },
  [types.SET_IS_AUTHORIZED](state, isAuthorized) {
    state.isAuthorized = isAuthorized
  },
  [types.SET_NEW_PERSON_FREE_ORDER_COUNT](state, newPersonFreeOrderCount) {
    state.newPersonFreeOrderCount = newPersonFreeOrderCount
    setNewPersonFreeOrderCount(newPersonFreeOrderCount)
  },
  [types.SET_IOS_IS_SHOW_LOGIN_BTN](state, iosIsShowLoginBtn) {
    state.iosIsShowLoginBtn = iosIsShowLoginBtn
  },
  [types.SET_IS_HAVE_UNFINISHED_ORDER](state, isHaveUnfinishedOrder) {
    state.isHaveUnfinishedOrder = isHaveUnfinishedOrder
    setStore(finishedStoreName, isHaveUnfinishedOrder)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
